module.exports = __webpack_public_path__ + "img/user-banner-gray.8009c7e6.png";